<div class="grid grid-cols-12 p-8">

  <div class="col-span-full pb-8">
    <p-card>
      <div class="hero-banner">
      <h2>FLYHT's Suite Of Solutions To Supercharge</h2>
      <h2>Your Operations Through Actionable Intelligence</h2>
      </div>
    </p-card>
  </div>
  <div class="col-span-4">
    <div *ngFor="let product of productService.getProducts()"
         (click)="onProductSelection(product)"
         class="p-row pb-4" style="cursor: pointer;">
      <p-card>
        <div class="grid grid-cols-12 product-card">
          <div class="col-span-5">
            <img [src]="product.productIcon" alt="">
          </div>
          <div class="col-span-7 pl-4 flex flex-col justify-between h-full">
            <h6>{{product.name}}</h6>

            <p class="text-xs"> {{product.description}}</p>
            <a class="text-xs link" href="{{product.brochureLink}}" target="_blank">Learn More</a>
          </div>
        </div>
      </p-card>
    </div>
  </div>
  <div class="col-span-8 pl-4">
    <img src="{{ selectedProduct.aboutImg }}"
         alt=""
         class="w-full full-image">
  </div>

</div>

<div class="acknowledgements-link">
  <small>
    <a [routerLink]="['/acknowledgements']" class="link">Acknowledgements</a>
  </small>
</div>